import { Theme } from '@mui/material';

const HALE_FOOTER_BG = '#000000';

export const styles = (theme: Theme, isHale = false) => {
  return {
    container: {
      padding: theme.custom.padding['5'],
      background: 'linear-gradient(180deg, #FFF 21.81%, #FFF2D6 100%)',
      display: 'flex',
      flexDirection: 'column',
      gap: theme.custom.gap['1_25'],
      '@media (max-width: 767px)': {
        padding: `${theme.custom.padding['3_5']} ${theme.custom.padding.medium} ${theme.custom.padding.mediumX}`,
      },
    },
    footerLabel: {
      color: 'text.nonary',
      fontSize: theme.typography.textSize.medium,
      fontWeight: theme.typography.fontWeight.normal,
      textAlign: 'center',
      '@media (max-width: 767px)': {
        fontSize: theme.typography.textSize['0_875'],
      },
    },
    divider: {
      borderRight: '1px solid',
      height: '4.4rem',
      borderColor: 'background.fourteenary',
      '@media (max-width: 767px)': {
        width: '80%',
        borderRight: 'none',
        height: 'auto',
      },
    },
    aboutSparkl: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.custom.gap['2_5'],
      '@media (max-width: 767px)': {
        flexDirection: 'column',
        gap: theme.custom.gap.medium,
      },
    },
    termsAndConditionsBox: {
      backgroundColor: isHale ? HALE_FOOTER_BG : 'text.secondary',
      padding: theme.custom.padding.medium,
      display: 'flex',
      alignItems: 'center',
      justifyContent: isHale ? 'space-between' : 'center',
      gap: theme.custom.gap.xLarge,
      ...(isHale && {
        paddingLeft: theme.custom.padding['7_5'],
        paddingRight: theme.custom.padding['7_5'],
        '@media (max-width: 767px)': {
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: theme.custom.gap.medium,
          paddingLeft: theme.custom.padding.medium,
          paddingRight: theme.custom.padding.medium,
        },
      }),
    },
    linksGroup: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.custom.gap.xLarge,
      ...(isHale && {
        '@media (max-width: 767px)': {
          gap: theme.custom.gap.large,
        },
      }),
    },
    poweredByGroup: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      '@media (max-width: 767px)': {
        marginLeft: 0,
        alignSelf: 'flex-end',
      },
    },
    link: {
      color: 'background.default',
      cursor: 'pointer',
      fontSize: theme.typography.textSize['0_875'],
      fontWeight: theme.typography.fontWeight.small,
      ...(isHale && {
        color: '#ffffff',
        '&:hover': {
          color: '#CBA052',
        },
      }),
      '@media (max-width: 767px)': {
        fontSize: theme.typography.textSize.small,
      },
    },
  };
};
